import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import classes from "./Insights.module.css";
import { SideBarMenu } from "../../../stories/SideBarMenu/SideBarMenu";
import { DropDown } from "../../../stories/DropDown/DropDown";
import { Tabs } from "../../../stories/Tabs/Tabs";
import { CoachInsightsSidebar } from "../../../stories/CoachInsightsSidebar/CoachInsightsSidebar";
import moment from "moment";
import Analytics from "./analytics/analytics";
import Transactions from "./transactions/transactions";
import {
  ChatFilled,
  ChatOutlined,
  HomeFilled,
  Homeoutlined,
  InsightsFilled,
  InsightsOutlined,
  NotificationFilled,
  Notificationoutlined,
  ReviewFilled,
  ReviewOutlined,
  ScheduleFilled,
  ScheduleOutlined,
  ShortLogo,
  doubleTickBlueIcon,
  NotificationAnnouncementIcon,
} from "../../../constant/imagePath";
import { InsightsMobile } from "./InsightsMobile";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook";
import { useHistory, useLocation } from "react-router";

const InsightsDesktop = () => {
  const history = useHistory();
  const path = useLocation()?.pathname?.split("/")[1];
  const sidebarMenus = [
    {
      icon: Homeoutlined,
      hoverIcon: HomeFilled,
      text: "Todo",
      onClick: () => history.push("/todo"),
    },
    {
      icon: Notificationoutlined,
      hoverIcon: NotificationFilled,
      text: "Notifications",
      onClick: () => history.push("/notifications"),
    },
    {
      icon: ScheduleOutlined,
      hoverIcon: ScheduleFilled,
      text: "Schedule",
      onClick: () => history.push("/schedule"),
    },
    {
      icon: ChatOutlined,
      hoverIcon: ChatFilled,
      text: "Chat",
      onClick: () => history.push("/chat"),
    },
    {
      icon: ReviewOutlined,
      hoverIcon: ReviewFilled,
      text: "Reviews",
      onClick: () => history.push("/reviews"),
    },
    {
      icon: InsightsOutlined,
      hoverIcon: InsightsFilled,
      text: "Insights",
      activeText: "insights",
      onClick: () => history.push("/insights"),
    },
  ];
  const [location, setLocation] = useState();
  const [period, setPeriod] = useState();

  const CoachInsightsSidebarData = {
    data: {
      currentEarning: "436",
      previousMonthEarning: "280",
      earningDays: 68,
      rating: 4.7,
      studentsSayings: [
        "Friendly to kids",
        "Competitive",
        "Discipline",
        "Caring",
      ],
    },
  };

  const [tabs, setTabs] = useState({ label: "Analytics" });

  const tabsdata = [{ label: "Analytics" }, { label: "Transactions" }];
  console.log({ path });

  return (
    <div className={[classes.InsightsScreen].join(" ")}>
      <SideBarMenu
        logo={ShortLogo}
        items={sidebarMenus}
        state={path}
        customStyle={{ minHeight: "100vh", height: "auto" }}
      />

      <Container fluid className={[classes.container].join(" ")}>
        <Row className={["g-0", classes.row].join(" ")}>
          <Col md={4} xl={3}>
            <CoachInsightsSidebar
              data={CoachInsightsSidebarData.data}
              customStyle={{ width: "100%", height: "100%" }}
            />
          </Col>
          <Col
            md={8}
            xl={9}
            className={[classes.p24, classes.mainContent].join(" ")}
          >
            <div className={[classes.insightHeader, classes.mb24].join(" ")}>
              <h3 style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}>
                Insights
              </h3>
              <div className={[classes.dflex].join(" ")}>
                <DropDown
                  options={[{
                    value: "All Locations",
                    label: "All Locations",
                  }]}
                  state={location}
                  setter={setLocation}
                  customStyle={{ width: "200px", height: "48px" }}
                  placeholder="Location"
                />

                <DropDown
                  options={[{ label: "This week", value: "This week" }]}
                  state={period}
                  setter={setPeriod}
                  placeholder="Period"
                  customStyle={{
                    marginLeft: "8px",
                    width: "200px",
                    height: "48px",
                  }}
                />
              </div>
            </div>
            <div className={[classes.relative].join(" ")}>
              <Tabs tabsData={tabsdata} state={tabs} setState={setTabs} />
              <div
                className={[classes.dateInTabs].join(" ")}
                style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
              >
                {moment().format("MMM DD, YYYY")}-
                {moment().format("MMM DD, YYYY")}
              </div>
            </div>
            {tabs.label === "Analytics" && <Analytics />}
            {tabs.label === "Transactions" && <Transactions />}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const Insights = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <InsightsMobile /> : <InsightsDesktop />;
};

export default Insights;
